import App from "./App.svelte";
import { firebase } from "./firebase/firebase.js";
import { refreshUser } from "./store/auth.js";

// import "./css/prop-to-class.css";

firebase.auth().onAuthStateChanged(authUser => {
  refreshUser(authUser);
});

let app = new App({
  target: document.body
});

export default app;
